var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlame = function SvgFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1645 8.90322C12.1561 10.5031 11.6909 11.5415 10.9789 12.281C10.3409 12.9428 9.07518 13.0569 8.71915 13.7941C8.15113 14.9672 7.65309 16.5922 7.93709 17.7881C8.57303 20.456 11.8762 21.6793 14.3108 20.383C16.7496 19.0844 17.2867 16.7884 16.2721 14.2118C15.6115 12.5389 14.4775 11.101 13.1645 8.90322M4.1819 5.92361C5.30516 7.45929 6.20073 8.68826 6.89681 9.6434C9.54667 6.15583 12.0491 2.85885 14.2197 0C17.0886 2.48643 19.3655 4.19954 21.3366 6.22374C26.504 11.534 25.1639 19.2036 18.6065 22.5224C13.1767 25.2718 6.57588 24.0954 2.95021 19.7337C-0.636424 15.4224 -0.335008 10.8505 4.1819 5.92361"
  })));
};
export default SvgFlame;